import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';

import toolsMarkup from '../markup/tools.js';
// import cropWrap from '../tools/cropWrapper.js';

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const mypopup = document.getElementById("mypopup");


// const cardPosterssecondBlock = cardPosters.querySelector('div[name=secondBlock]');

const mainTabPane = document.querySelector('#festAppTelegramBot');
// const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
// const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const menuBt =  document.querySelector('#MenuTelegramBot');



const onSuccessPointsLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  // if (loadedPoints.status === 200) {

  //   $(cardPosters).modal('hide');
  //   // console.log(loadedPoints);
  //   pointsMarkup.drawDataInContainer(loadedPoints.data);a
  // } else {
  //   pointsMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);

  // }
};

mainTabPaneBTReload.addEventListener('click', function () {
  getData();
});

// mainTabPaneBTAdd.addEventListener('click', function () {

// });

// mainTabPaneBody.addEventListener('click', function (evt) {
//   // определить тип на что нажали

 
// });

function clearCard() {
  // cardPostersPhoto.src = 'https://cdn1.iconfinder.com/data/icons/hipster-4/512/hipster-fashion-style-beard-man-glasses-512.png';
  cardPostersName.value = '';
  cardPostersDesc. value = '';

}
const getData = () => {
  // pointsMarkup.cleanContainer();
  // pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);
  displayLastUsers(false);

  xhr.request = {
    metod: 'GET',
    url: 'telegrambot',
    data: '',
    callbackSuccess: (answer) => {
      if (answer.status === 200) {
        mainTabPane.querySelector('h3[name=countUsers]').innerHTML = answer.data.users;
        mainTabPane.querySelector('h3[name=countUsers24]').innerHTML = answer.data.users24
        mainTabPane.querySelector('h3[name=countRequests]').innerHTML = answer.data.requests;
        mainTabPane.querySelector('h3[name=countRequests24]').innerHTML = answer.data.requests24;
        // отрисовка настроек
        let link = returnTextInArray(answer.data.settings,'link');
        // console.log(link);
        mainTabPane.querySelector('a[name=link]').innerHTML = link;
        mainTabPane.querySelector('a[name=link]').href = link;
        displayServerData(answer.data.settings);
        displayLastUsers(answer.data.lastUsers);

      } else 
      {
        // сервер не ответил
      }
    }
  }
  
};

//<div class="cloud">mike</div>

  mainTabPane.querySelector('div[name=telegramUsersBody]').addEventListener('click', function (evt) {
    if(evt.target.attributes.userID)
    {
      if(confirm('Вы уверены, что хотите добавить данного пользователя в расслыку?'))
        xhr.request = {
          metod: 'POST',
          url: `telegrambot/0/mailing/${evt.target.attributes.userID.nodeValue}`,
          data: '',
          callbackSuccess: (answer) => {
            // обработка ответа
            if (answer.status == 200) 
              tools.showAlert('Пользователь добавлен в список массовой рассылки!');
            // xhr.request.setMessage('Данные обновлены!');
          }
        };

    }
  });


mainTabPane.querySelector('button[name=showAllUsersList]').addEventListener('click',function(evt) {

  if( mainTabPane.querySelector('div[name=telegramUsersBody]').classList.contains('max-height-200')){
    mainTabPane.querySelector('button[name=showAllUsersList]').innerHTML = 'Скрыть последние 100';
    mainTabPane.querySelector('div[name=telegramUsersBody]').classList.remove('max-height-200');
  } else {
    mainTabPane.querySelector('button[name=showAllUsersList]').innerHTML = 'Отобразить последние 100';
    mainTabPane.querySelector('div[name=telegramUsersBody]').classList.add('max-height-200');
  }
});




function displayLastUsers(lastUsers){
  let htmlBody = '';
  if (lastUsers)
    lastUsers.forEach((cElement) => {  
      htmlBody += `<div class="cloud popup" userID=${cElement.id} popupAlert="Последняя активность" popupMsg="${cElement.timeActivity}">${cElement.name}</div>`;
    });

  mainTabPane.querySelector('div[name=telegramUsersBody]').innerHTML = htmlBody;



  const date = new Date();
  const curTimeZone = (date.getTimezoneOffset())/60 * -1;


  let allPopUpListenerClass =   mainTabPane.querySelector('div[name=telegramUsersBody]').querySelectorAll('.popup');
  allPopUpListenerClass.forEach((buttonItem) => {
    if (buttonItem.attributes.popupAlert) {
      buttonItem.addEventListener("mouseover", (evt) => {
        mypopup.querySelector('b').innerHTML = ''; 

        if (evt.target.attributes.popupAlert)
          mypopup.querySelector('b').innerHTML = evt.target.attributes.popupAlert.nodeValue;

        if (evt.target.attributes.popupMsg) {
          mypopup.querySelector('div').style.display = 'block';

          if(evt.target.attributes.popupMsg.nodeValue.length == 19)
            mypopup.querySelector('div').innerHTML = tools.dateStringFullAddTimeZone(evt.target.attributes.popupMsg.nodeValue, curTimeZone);
          else
              mypopup.querySelector('div').innerHTML = evt.target.attributes.popupMsg.nodeValue;
        }
        else{
          mypopup.querySelector('div').style.display = 'none';
          mypopup.querySelector('div').innerHTML = '';
        }
        

        let iconPos = evt.target.getBoundingClientRect();
        let shift = 0;

        if(evt.target.attributes.popupShift)
          shift = evt.target.attributes.popupShift.nodeValue;

          mypopup.style.left = (iconPos.right - 90 - shift) + "px";


        mypopup.style.top = (window.scrollY + iconPos.top + 30) + "px";
        mypopup.style.display = "block";
      });
      buttonItem.addEventListener("mouseout", ()=> {
        mypopup.style.display = "none";
      });
    }
  });



}


function displayServerData(arr){
  arr.forEach((cElement) => {  
    if (cElement.tsKey && cElement.tsKey.length > 5 && cElement.tsKey.includes('block')) 
      mainTabPane.querySelector(`input[name=${cElement.tsKey}]`).checked = Boolean(cElement.tsValue);
  

    if (cElement.tsKey && cElement.tsKey.length > 5 && cElement.tsKey.includes('txt')) {
      let txtInput = mainTabPane.querySelector(`textarea[name=${cElement.tsKey}]`);

      let unformattedText = cElement.tsText;
      unformattedText = unformattedText.replaceAll('%0A','\n');
      txtInput.value = unformattedText;
      txtInput.setAttribute('oldValue', unformattedText);
      setTimeout(function() { 

        txtInput.style.height = txtInput.scrollHeight + 10 + "px"; 
       }, 200);
    }

  });
} 
// Обработка input checkbox

function addEventsListenersForInputs() {
  let keys = ['blockLentaBeforeStart', 'blockScheduleBeforeStart', 'blockWorksBeforeStart', 'blockDisplayWorkTypeCompetition', 'blockDisplayWorkTypeNonCompetition','blockDisplayWorkTypeMediateka'];
  keys.forEach((element) => {
    if(!mainTabPane.querySelector(`input[name=${element}]`))
      return;

    mainTabPane.querySelector(`input[name=${element}]`).addEventListener('click', function (evt){
      let newValue = evt.target.checked;

      xhr.request = {
        metod: 'PUT',
        url: 'telegrambot/settings',
        data: `${evt.target.attributes.name.nodeValue}='${(newValue ? '1': '0')}'`,
        callbackSuccess: (answer) => {
          // обработка ответа
          if (answer.status == 200) 
            tools.showAlert('Данные обновлены!');
          // xhr.request.setMessage('Данные обновлены!');
        }
      };

    });
    
  })
};

// Обработка текстовых Полей

function addEventsListenersForTextArea() {
  let keys = ['txtFooterJury', 'txtContants'];
  keys.forEach((element) => {

    if(!mainTabPane.querySelector(`textarea[name=${element}]`))
      return;
    // сравнение значения с первоначальным
    mainTabPane.querySelector(`textarea[name=${element}]`).addEventListener('keyup', function (evt){
      if(evt.target.value != evt.target.getAttribute('oldValue'))
        mainTabPane.querySelector(`button[name=${element}]`).classList.remove('divDisabled');
      else
        mainTabPane.querySelector(`button[name=${element}]`).classList.add('divDisabled');
    })
    //добавление события на нажатие кнопки сохранить
    mainTabPane.querySelector(`button[name=${element}]`).addEventListener('click', function (evt){

      // заморзка текствого поля и отправка значения на сервер
      mainTabPane.querySelector(`textarea[name=${element}]`).classList.add('divDisabled');
      let localValue = mainTabPane.querySelector(`textarea[name=${element}]`).value.replaceAll('\n','%0A');

      localValue = localValue.replaceAll('=','%3D');
      xhr.request = {
        metod: 'PUT',
        url: 'telegrambot/settings/txt',
        data: `${evt.target.attributes.name.nodeValue}='${(localValue)}'`,
        callbackSuccess: (answer) => {
          // обработка ответа
          if (answer.status == 200) {
            mainTabPane.querySelector(`textarea[name=${element}]`).classList.remove('divDisabled');
            evt.target.classList.add('divDisabled');
            tools.showAlert('Данные обновлены!');
          }
          // xhr.request.setMessage('Данные обновлены!');
        }
      };
    });

  });

  // body...
}


function addEventsListeners () {

}
function clicKOnCheckBox(evt){
  console.log(evt);

}

function returnValueInArray(arr, keyNeed){
 
  arr.forEach((cElement) => {
    if(cElement.tsKey === keyNeed)
      return cElement.tsValue;

  });

  return 0;
}


function returnTextInArray(arr, keyNeed){
 
 let answer = '';
  arr.forEach((cElement) => {
    if(cElement.tsKey === keyNeed)
      answer =  cElement.tsText;
  });

  return answer;
}

// function forEach(data, callback) {
//   for (let key in data) {
//     if (data.hasOwnProperty(key)) {
//       callback(key, data[key]);
//     }
//   }
// }


// cardPostersAddChange.addEventListener('click', function () {

//     xhr.request = {
//       metod: 'PUT',
//       url: `posters/${cardPosters.getAttribute('currentPoster')}`,
//       data: `creator=${cardPostersName.value}&desc=${cardPostersDesc.value}`,
//       callbackSuccess: onSuccessAddLoad
//     };
// });

// const onSuccessAddLoad = (loadedPoints) => {
// // document.querySelector(`#${loaderSpinnerId}`).remove();
//   if (loadedPoints.status === 200) {
//     $(cardPosters).modal('hide');
//     getData();
//   }
// };



export default {

  start() {
    // getData();
      addEventsListenersForInputs();
      addEventsListenersForTextArea();
      menuBt.addEventListener('click', getData);
  },

  redraw: getData,

  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', getData);
  }
};
